module.exports = (__webpack_require__(6882))("vr");